import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useState } from 'react'

export const useRefresh = () => {
    const [isRefreshing, setIsRefreshing] = useState(false)
    const queryClient = useQueryClient()

    const refresh = useCallback(async () => {
        setIsRefreshing(true)
        await queryClient.invalidateQueries()
        await queryClient.refetchQueries()
        setIsRefreshing(false)
    }, [queryClient])

    return { refresh, isRefreshing }
}
